export default __webpack_public_path__ + "static/kiteboarding-9cc1d612602d9d18907995cbe21ff4c5.svg";